import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

export const LogoIcon = () => {
  return (
    <div>
      <img src="/my-company-logo.png" alt="logo"/>
    </div>
  );
};